var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classnames from 'classnames';
import { Icon } from '../Icon';
import { Tooltip } from '../Tooltip';
import { useScreenSize } from '../../hooks';
export const ProgressTrackerStep = (_a) => {
    var { active = false, className, completed = false, disabled, editing, href, label, size = 'medium', stepNumber, hideLabels } = _a, props = __rest(_a, ["active", "className", "completed", "disabled", "editing", "href", "label", "size", "stepNumber", "hideLabels"]);
    const screensize = useScreenSize();
    const getStepContent = () => {
        if (size === 'medium')
            return (React.createElement("div", { className: "ProgressTrackerStep__icon" }, getBadge()));
        return React.createElement("div", { className: "ProgressTrackerStep__simple" });
    };
    const getBadge = () => {
        if (size === 'small')
            return;
        if (completed)
            return React.createElement(Icon, { name: "check_circle" });
        if (editing)
            return React.createElement(Icon, { name: "edit" });
        return stepNumber;
    };
    const StepElement = href && !disabled ? 'a' : 'div';
    const getLabel = () => {
        if (!label || hideLabels || screensize.smallerThan.tablet)
            return;
        return React.createElement("div", { className: "ProgressTrackerStep__label" }, label);
    };
    const getTooltipLabel = () => {
        if (screensize.smallerThan.tablet || hideLabels)
            return label;
    };
    const ProgressTrackerStepClasses = classnames('ProgressTrackerStep', className, {
        'ProgressTrackerStep--active': active,
        'ProgressTrackerStep--complete': completed,
        'ProgressTrackerStep--incomplete': !active && !completed && !editing,
        'ProgressTrackerStep--clickable': href != null || props.onClick != null,
        'ProgressTrackerStep--disabled': disabled,
        'ProgressTrackerStep--editing': editing,
        'ProgressTrackerStep--hideLabels': hideLabels,
        [`ProgressTrackerStep--${size}`]: size,
    });
    return (React.createElement(StepElement, Object.assign({ className: ProgressTrackerStepClasses, tabIndex: (props.href || props.onClick) && 0, "data-anvil-component": "ProgressTrackerStep", href: !disabled && href }, props),
        React.createElement(Tooltip, { text: getTooltipLabel(), portal: true, direction: "b", el: "div" }, getStepContent()),
        getLabel()));
};
//# sourceMappingURL=ProgressTrackerStep.js.map